/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1ExamItemLevelsQueryResponse,
  GetApiV1ExamItemLevels401,
  GetApiV1ExamItemLevels500,
} from "../../types/examQuestionLibraryController/GetApiV1ExamExamItemLevels.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1ExamExamItemLevels } from "../../clients/examQuestionLibraryController/getApiV1ExamExamItemLevels.ts";

export const getApiV1ExamExamItemLevelsQueryKey = () =>
  [{ url: "/api/v1/exam/exam-item-levels" }] as const;

export type GetApiV1ExamExamItemLevelsQueryKey = ReturnType<
  typeof getApiV1ExamExamItemLevelsQueryKey
>;

export function getApiV1ExamExamItemLevelsQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1ExamExamItemLevelsQueryKey();
  return queryOptions<
    GetApiV1ExamItemLevelsQueryResponse,
    ResponseErrorConfig<GetApiV1ExamItemLevels401 | GetApiV1ExamItemLevels500>,
    GetApiV1ExamItemLevelsQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1ExamExamItemLevels({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todos os níveis de questão disponíveis para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Listar níveis de questão para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/exam/exam-item-levels}
 */
export function useGetApiV1ExamExamItemLevels<
  TData = GetApiV1ExamItemLevelsQueryResponse,
  TQueryData = GetApiV1ExamItemLevelsQueryResponse,
  TQueryKey extends QueryKey = GetApiV1ExamExamItemLevelsQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1ExamItemLevelsQueryResponse,
        ResponseErrorConfig<
          GetApiV1ExamItemLevels401 | GetApiV1ExamItemLevels500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1ExamExamItemLevelsQueryKey();

  const query = useQuery(
    {
      ...getApiV1ExamExamItemLevelsQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1ExamItemLevels401 | GetApiV1ExamItemLevels500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
